import { shallowEqual, useSelector } from "react-redux";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";
import { defaultProfileImage } from "../../../utils/constants";
import { CommunityMediaIcon } from "../../community/components/CommunityMediaIcon";
import { CommunityVidePreview } from "../../community/components/CommunityVidePreview";
import { CommunityMediaEnum } from "../../community/enums/CommunityMediaEnum";
import { CommunityDiscussComments } from "../../community/models/CommunityDiscussComments";
import { CommunityAdminPopUp } from "./CommunityAdminPopUp";
import { UserModel } from "../../../modules/auth/models/UserModel";
import { RootState } from "../../../../setup";

type Props = {
    comment: CommunityDiscussComments;
    onDeleteComment: () => void;
    onSuspendUser: () => void;
}


export const CommunityAdminComment = ({ comment, onDeleteComment, onSuspendUser }: Props) => {
    const user = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel;
    const _parseDate = (date: string) => new Date(date)
        .toLocaleString('es-MX', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });
    return (
        <div className="community-comment">
            <img src={toAbsoluteUrl(comment.avatar) || defaultProfileImage} onError={(e) => { e.currentTarget.src = defaultProfileImage }} alt={comment.author} />
            <div className="community-comment__info">
                <div className="community-comment__info__header">
                    <span className="author">{comment.author}</span>
                    { comment.isMine && (<div className="host"><span>HOST</span></div>) }

                    <span className="dot">•</span>

                    <span className="date">{_parseDate(comment.createdAt)}</span>
                </div>

                {comment.reply && (
                    <div className="community-comment__info__reply">
                        <img src={toAbsoluteUrl(comment.reply.avatar) || defaultProfileImage} onError={(e) => { e.currentTarget.src = defaultProfileImage }} alt={comment.reply.author} />
                        <span className="author">{comment.reply.author}</span>
                        { comment.reply.isMine && (<div className="host"><span>HOST</span></div>) }
                        <span className="content-preview">{comment.reply.content}</span>
                    </div>
                )}

                <div className="community-comment__info__content">
                    {comment.content}
                </div>

                {comment.files && (
                    <div className="community-comment__info__images">
                        { comment.files.map(f => (
                            <>
                                { f.resourceType === CommunityMediaEnum.image ? (
                                    <img style={{ cursor: 'pointer' }} src={toAbsoluteUrl(f.file)} alt={f.title} key={f.id} onClick={() => window.open(f.file, '_blank')} />
                                ): f.resourceType === CommunityMediaEnum.video ? (
                                    <CommunityVidePreview src={toAbsoluteUrl(f.file)} title={f.title}/>
                                ): (
                                    <div style={{ display: 'flex', alignItems: 'center', background: '#f5f5f5', cursor: 'pointer' }} onClick={() => window.open(f.file, '_blank')}>
                                        <CommunityMediaIcon type={f.resourceType} />
                                        <span style={{ paddingRight: '12px', fontSize: 'var(--text-xs)', color: 'var(--color-dark-gray)'  }}> { f.title } </span>
                                    </div>
                                )}
                            </>
                        ))}
                    </div>
                )}

                <div className="community-comment__info__actions">
                    <CommunityAdminPopUp 
                        items={[
                            {
                                label: 'Delete',
                                cb: () => onDeleteComment()
                            },
                            ...(user.id !== comment.authorId ? [{
                                label: 'Suspend user',
                                cb: () => onSuspendUser()
                            }]: [])
                        ]}
                    />
                </div>

            </div>


        </div>
    )
}